// extracted by mini-css-extract-plugin
export default {"root":"MainSingleFormContent_root__eeC5b"};